import React from "react";
import Navbar from "../component/common/Navbar";
import "./style.css";

const Explore = () => {
  const gamingCafes = [
    {
      id: 1,
      name: "TUF Esports Cafe",
      location: "Jaipur, Rajasthan",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756883389/TUF_h6vvwh.jpg",
      rating: 4.5,
      price: "₹200/hour"
    },
    {
      id: 2,
      name: "Shinzx Gaming Hub",
      location: "Jaipur, Rajasthan",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756885068/CAFE2_vvgq7a.png",
      rating: 4.3,
      price: "₹150/hour"
    },
    {
      id: 3,
      name: "GGWP ",
      location: "Udaipur, Rajasthan",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756885732/GGW_bdmfbh.jpg",
      rating: 4.7,
      price: "₹300/hour"
    },
    {
      id: 4,
      name: "The Playoo Gaming Lounge",
      location: "Udaipur, Rajasthan",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756886358/Playnoo_dqhivt.jpg",
      rating: 4.6,
      price: "₹250/hour"
    },
    {
      id: 5,
      name: "Gamers H.Q.",
      location: "Rajkot, Gujarat",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756887375/cafe5_ce6jk6.jpg",
      rating: 4.4,
      price: "₹180/hour"
    },
    {
      id: 6,
      name: "Ministry Of Esports",
      location: "Pune, Maharashtra",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756888397/cafe6_lo5plu_1_y1izvs.jpg",
      rating: 4.2,
      price: "₹160/hour"
    }
    ,
    {
      id: 7,
      name: "TGT Gaming ",
      location: "Pune, Maharashtra",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756456816/cafe1_hwsdvx.jpg",
      rating: 4.2,
      price: "₹160/hour"
    }
    ,
    {
      id: 8,
      name: "Legends Gaming",
      location: "Pune, Maharashtra",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756889131/cafe8_rkm9gn.jpg",
      rating: 4.2,
      price: "₹160/hour"
    }
    ,
    {
      id: 9,
      name: "Shaukeens Gaming Cafe",
      location: "Pune, Maharashtra",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756889591/shakeen_rpknke.jpg",
      rating: 4.2,
      price: "₹160/hour"
    }
    ,
    {
      id: 10,
      name: "Cybercore Gaming Cafe",
      location: "Pune, Maharashtra",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756890713/cafe10_nerzuo.jpg",
      rating: 4.2,
      price: "₹160/hour"
    },
    {
      id: 11,
      name: "LevelUp Gaming ",
      location: "Patna, Bihar",
      image: "https://res.cloudinary.com/dhhslwmda/image/upload/v1756890655/cafe11_xedmax.jpg",
      rating: 4.2,
      price: "₹160/hour"
    }

    
    


  ];

  return (
    <div className="explore-page min-h-screen bg-black text-white">
      <Navbar />
      {/* Hero Section */}
      <div className="hero-section bg-gradient-to-b from-gray-900 to-black py-20">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              <span className="text-white">Explore</span>{" "}
              <span className="text-[#D9A82F]">Gaming Cafes</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-8">
              Discover the best gaming cafes across India. Book your slot and experience
              premium gaming setups with fellow gamers.
            </p>
            <div className="flex justify-center gap-4">
              
            </div>
          </div>
        </div>
      </div>

      {/* Gaming Cafes Grid */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {gamingCafes.map((cafe) => (
            <div
              key={cafe.id}
              className="bg-black rounded-xl overflow-hidden shadow-2xl hover:shadow-[#D9A82F]/20 transition-all duration-300 hover:scale-105"
            >
              {/* Cafe Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cafe.image}
                  alt={cafe.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute top-4 right-4 bg-black bg-opacity-70 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {cafe.price}
                </div>
                <div className="absolute bottom-4 left-4 bg-[#D9A82F] text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center gap-1">
                  <span>★</span>
                  <span>{cafe.rating}</span>
                </div>
              </div>

              {/* Cafe Info */}
              <div className="p-6">
                <div className="flex items-center gap-2 mb-2">
                  {cafe.id === 1 && (
                    <img 
                      src="https://res.cloudinary.com/dhhslwmda/image/upload/v1756882539/Frame_5_ri3trb.jpg" 
                      alt="TUF Esports Cafe Logo" 
                      className="w-8 h-8 object-contain bg-white rounded-full p-0.5 shadow-md"
                    />
                  )}
                  {cafe.id === 2 && (
                    <img 
                      src="https://res.cloudinary.com/dhhslwmda/image/upload/v1756885059/Logo-01_thjgee.png" 
                      alt="Shinzx Gaming Hub Logo" 
                      className="w-8 h-8 object-contain bg-white rounded-full p-0.5 shadow-md"
                    />
                  )}
                  {cafe.id === 4 && (
                    <img 
                      src="https://res.cloudinary.com/dhhslwmda/image/upload/v1756886356/logo_playooo_b8xjcr.png" 
                      alt="The Playoo Gaming Lounge Logo" 
                      className="w-8 h-8 object-contain bg-white rounded-full p-0.5 shadow-md"
                    />
                  )}
                  {cafe.id === 7 && (
                    <img 
                      src="https://res.cloudinary.com/dhhslwmda/image/upload/v1756888688/tgt_1_with_shadow_logo_otvndq.png" 
                      alt="TGT Gaming Logo" 
                      className="w-8 h-8 object-contain bg-white rounded-full p-0.5 shadow-md"
                    />
                  )}
                  {cafe.id === 8 && (
                    <img 
                      src="https://res.cloudinary.com/dhhslwmda/image/upload/v1756889132/legendry_gaming_logo_xkcegq.jpg" 
                      alt="Legends Gaming Logo" 
                      className="w-8 h-8 object-contain bg-white rounded-full p-0.5 shadow-md"
                    />
                  )}
                  {cafe.id === 9 && (
                    <img 
                      src="https://res.cloudinary.com/dhhslwmda/image/upload/v1756889573/3DLogo_x2si5u.jpg" 
                      alt="Shaukeens Gaming Cafe Logo" 
                      className="w-8 h-8 object-contain bg-white rounded-full p-0.5 shadow-md"
                    />
                  )}
                  {cafe.id === 10 && (
                    <img 
                      src="https://res.cloudinary.com/dhhslwmda/image/upload/v1756890408/logo10_mi3ean.png" 
                      alt="Cybercore Gaming Cafe Logo" 
                      className="w-8 h-8 object-contain bg-white rounded-full p-0.5 shadow-md"
                    />
                  )}
                  <h3 className="text-xl font-bold">{cafe.name}</h3>
                </div>
                <p className="text-gray-400 mb-4 flex items-center gap-2">
                  <span>📍</span>
                  {cafe.location}
                </p>
                <div className="flex justify-between items-center">
                  <button className="bg-[#D9A82F] hover:bg-[#9E8110] text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                    Book Now
                  </button>
                 
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Load More Section */}
      <div className="text-center py-16">
        <button className="bg-gray-800 hover:bg-gray-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors">
          Load More Cafes
        </button>
      </div>
    </div>
  );
};

export default Explore; 